module.exports = __webpack_public_path__ + "static/img/Jake_Carlisle_mobile.37358e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake_Carlisle_mobile.jpg
// module id = Pz0F
// module chunks = 0